import { createAbpCrudService } from '@/api/abpCrudService';
import type { CentDatatableInput, CentDto, CreateCentDto, UpdateCentDto } from '@/api/types/cents';

// Finkit.Host.Cents.CentsAppService — standard ABP CRUD at /api/app/cents.
export const centsApi = createAbpCrudService<CentDto, CreateCentDto, UpdateCentDto, CentDatatableInput>(
  '/api/app/cents',
);
